import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { formatNumber } from '../../../../../internal/utils/formatNumber';
export function useSliderMarks(_ref) {
  let {
    step,
    marks: marksProp,
    min,
    max
  } = _ref;
  return React.useMemo(() => {
    if (Array.isArray(marksProp)) {
      return marksProp.slice().sort((a, b) => {
        return a.value - b.value;
      }).map(mark => {
        if (typeof mark.label !== 'number') {
          return mark;
        }
        return _objectSpread(_objectSpread({}, mark), {}, {
          label: formatNumber(mark.label)
        });
      });
    }
    if (marksProp && step !== null) {
      return [...Array(Math.floor((max - min) / step) + 1)].map((_, index) => ({
        value: min + step * index
      }));
    }
    return [];
  }, [marksProp, min, max, step]);
}